export const unifyAddress = (address: string) => {
  return address.toLowerCase()
}
